module.exports = __webpack_public_path__ + "img/jg2.77bdd276.png";